module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/ten.2acc505.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/ten.jpg
// module id = 9w2i
// module chunks = 0